import React from 'react';
import style from './Signin.module.css';

function Signin() {
  return (
    <div className={style.ctn}>
      <div>
        <h1 className={style.title}>Page in progress</h1>
        <h5 className={style.version}>sorry to disturb</h5>
      </div>
    </div>
  );
}

export default Signin;
